<template>
  <v-row>
    <v-col cols="12">
        <branch-ingredient-card></branch-ingredient-card> 
    </v-col>
  </v-row>
</template>
<script>
import BranchIngredientCard from "@/components/ingredient/BranchIngredientCard";

export default {
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "Branch Ingredient List",
  },

  components: {
    BranchIngredientCard
  },

  data() {
    return {
    };
  },
};
</script>